._update-in-progress_1nwd2_1 {
  width: 18px;
  display: flex;
  justify-content: center; }
